import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import { TableInnerWrapper, BottomGradient } from './styles';
import TableConfiguration from '../../utils/tableConfiguration/tableConfiguration';

class DynamicTable extends Component {
  getColums = (data) => {
    const { isMobile, competitionId, isGazzanet } = this.props;
    const table = new TableConfiguration(this.props.tableRowsKey, isMobile, competitionId, isGazzanet);
    let returnData = [];
    if (data) {
      if (this.props.tableRowsKey === 'competitionTeams') {
        returnData = table.createColumnsConfiguration(Object.keys(data[this.props.tableRowsKey][0][this.props.tableId]));
      } else {
        returnData = table.createColumnsConfiguration(Object.keys(data[this.props.tableRowsKey][0]));
      }
    }
    return returnData;
  };

  getColumsHeader = (data) => {
    const { isMobile, competitionId } = this.props;
    const table = new TableConfiguration(this.props.tableRowsKey, isMobile, competitionId);
    let returnData = [];
    if (data) {
      if (this.props.tableRowsKey === 'competitionTeams') {
        returnData = table.createColumnsConfigurationWithTitle(Object.keys(data[this.props.tableRowsKey][0][this.props.tableId]), data[this.props.hasTitle]);
      } else {
        returnData = table.createColumnsConfigurationWithTitle(Object.keys(data[this.props.tableRowsKey][0]), data[this.props.hasTitle]);
      }
    }
    return returnData;
  };

  render() {
    const {
      data,
      isStandingWidget,
      dictionary,
      tableId,
      tableRowsKey,
      hasTitle,
      isSortable,
      actions,
      isMobile,
      teamDrop,
      roleDrop,
      countryDrop,
      isTopScorer,
      isHallOfFame,
      hideHeader,
      filterHonour,
      enableGradient,
      isGazzanet,
      //competitionId,
      sportId,
    } = this.props;
    if (data && data.contents && tableId && sportId === '1') {
      data.contents.forEach(c => c[tableRowsKey] = c[tableRowsKey].sort((a, b) => (a[tableId].position - b[tableId].position)));
    }
    if (data && data.tableRowsKey && data.contents && sportId === '2') {
      data.contents.forEach(c => c[data.tableRowsKey] = c[data.tableRowsKey].sort((a, b) => (Number(a.rank) - Number(b.rank))));
    }
    //console.log(teamDrop);
    let counter = 0;
    let honourCounter = 0;
    return (
      <div>
        {data && data.contents && data.contents.map((table, index) => (
          <TableInnerWrapper key={index}>
            {!hideHeader &&
            (hasTitle ?
              <TableHeader
                colums={this.getColumsHeader(table)}
                dictionary={dictionary[tableRowsKey]}
                isSortable={isSortable}
                actions={actions}
                isMobile={isMobile}
              />
              :
              <TableHeader
                colums={this.getColums(table)}
                dictionary={dictionary[tableRowsKey]}
                isSortable={isSortable}
                actions={actions}
                isMobile={isMobile}
              />)
            }
            {isHallOfFame && table[tableRowsKey] && table[tableRowsKey].slice(0, filterHonour).map((team, i) => (
              <TableRow
                colums={this.getColums(table)}
                row={tableId ? team[tableId] : team}
                key={i}
                countering={honourCounter += 1}
              />
            ))
            }
            {isTopScorer && !isGazzanet && table[tableRowsKey] && table[tableRowsKey].slice(0, 4).map((team, i) => (
              <span key={i}>
                {team.teamName.match(teamDrop) && team.playerRole.match(roleDrop) && team.playerCountry.match(countryDrop) &&
                (
                  <TableRow
                    colums={this.getColums(table)}
                    row={tableId ? team[tableId] : team}
                    key={i}
                    countering={counter += 1}
                  />
                )
                }
              </span>
            ))
            }
            {isTopScorer && isGazzanet && table[tableRowsKey] && table[tableRowsKey].slice(0, 20).map((team, i) => (
              <span key={i}>
                {team.teamName.match(teamDrop) && team.playerRole.match(roleDrop) && team.playerCountry.match(countryDrop) &&
                (
                  <TableRow
                    colums={this.getColums(table)}
                    row={tableId ? team[tableId] : team}
                    key={i}
                    countering={counter += 1}
                    isGazzanet={isGazzanet}
                  />
                )
                }
              </span>
            ))
            }
            {isTopScorer && counter === 0 &&
            <h1>Nessun risultato trovato.</h1>
            }
            {isStandingWidget && sportId !== '2' && !isTopScorer && !isHallOfFame && table[tableRowsKey] && table[tableRowsKey].slice(0, 10).map((team, i) => (
              <TableRow
                colums={this.getColums(table)}
                row={tableId ? team[tableId] : team}
                key={i}
              />
            ))
            }
            {isStandingWidget && sportId === '2' && !isTopScorer && !isHallOfFame && table[tableRowsKey] && table[tableRowsKey].map((team, i) => (
              <TableRow
                colums={this.getColums(table)}
                row={tableId ? team[tableId] : team}
                key={i}
              />
            ))
            }
            {enableGradient &&
              <BottomGradient />
            }
          </TableInnerWrapper>
        ))
        }
      </div>
    );
  }
}

DynamicTable.propTypes = {
  actions: PropTypes.any,
  data: PropTypes.any,
  dictionary: PropTypes.any,
  tableId: PropTypes.any,
  hasTitle: PropTypes.any,
  isSortable: PropTypes.bool,
  tableRowsKey: PropTypes.any,
  isMobile: PropTypes.bool,
  competitionId: PropTypes.any,
  teamDrop: PropTypes.string,
  roleDrop: PropTypes.string,
  countryDrop: PropTypes.string,
  isTopScorer: PropTypes.bool,
  isHallOfFame: PropTypes.bool,
  hideHeader: PropTypes.any,
  filterHonour: PropTypes.number,
  isStandingWidget: PropTypes.bool,
  enableGradient: PropTypes.bool,
  isGazzanet: PropTypes.bool,
  sportId: PropTypes.any,
};

export default DynamicTable;



// WEBPACK FOOTER //
// ./src/components/DynamicTable/index.js